/**
 * Employee Web — `/me/notifications` full-page inbox route.
 *
 * Quick task 260509-03r. Mirrors HR Admin's `/notifications` route; the
 * Employee surface lives under the `/me/` namespace per app convention.
 */
import { createFileRoute } from "@tanstack/react-router";
import { NotificationsInboxPage } from "../features/notifications";

export const Route = createFileRoute("/_auth/me/notifications")({
  component: NotificationsInboxPage,
  staticData: { breadcrumb: { labelKey: "common:nav.notifications" } },
});
